import {ValueObject} from '@s-ui/domain'

const CANCELLED = 'cancelled'
const FAILED = 'failed'

/**
 * @implements ValueObject
 */

export class StatusTradeRatingsValueObject extends ValueObject {
  /**
   * @param {String} status
   */

  constructor({status}) {
    super({status})

    this._status = status
  }

  getStatus = () => {
    return this._status === 200 ? CANCELLED : FAILED
  }

  toJSON() {
    return {
      status: this.getStatus()
    }
  }
}
